import {
  ICON_ALERT_CIRCLE_OUTLINE, ICON_CHECK_CIRCLE_OUTLINE, ICON_INFORMATION_OUTLINE, MessageType,
} from '@doveit/bricks';
import { PerformanceRating } from '../../../providers/api/dtos';

export const configByCrPerformanceRating: Record<PerformanceRating | 'NOT_DEFINED', {
  variant: MessageType,
  title: string,
  hint?: {
    title: string,
    icon: string,
  }
}> = {
  CRITICAL: {
    variant: 'critical',
    title: 'Il {CR} del team è molto sotto la media ({CR_PERFORMANCE}%)',
    hint: {
      title: 'La situazione è critica: serve un cambio di marcia immediato',
      icon: ICON_ALERT_CIRCLE_OUTLINE,
    },
  },
  BELOW_EXPECTATIONS: {
    variant: 'warning',
    title: 'Il {CR} del team è sotto la media ({CR_PERFORMANCE}%)',
    hint: {
      title: 'La situazione è a rischio: serve costanza e attenzione',
      icon: ICON_ALERT_CIRCLE_OUTLINE,
    },
  },
  NEARLY_ON_TRACK: {
    variant: 'info',
    title: 'Il {CR} del team è quasi nella media ({CR_PERFORMANCE}%)',
    hint: {
      title: 'Continua così: basta un piccolo sforzo in più',
      icon: ICON_INFORMATION_OUTLINE,
    },
  },
  ON_TRACK: {
    variant: 'info',
    title: 'Il {CR} del team è nella media ({CR_PERFORMANCE}%)',
    hint: {
      title: 'Continua così: sei in linea con le aspettative',
      icon: ICON_INFORMATION_OUTLINE,
    },
  },
  ABOVE_EXPECTATIONS: {
    variant: 'success',
    title: 'Il {CR} del team è sopra la media ({CR_PERFORMANCE}%)',
    hint: {
      title: 'Ottimo lavoro: sei avanti rispetto al piano',
      icon: ICON_CHECK_CIRCLE_OUTLINE,
    },
  },
  NOT_DEFINED: {
    variant: 'neutral',
    title: 'Il {CR} del team non è disponibile',
  },
};
